import { ClientRole } from '../types';

const ROLE_KEY = 'muzloto_role';

/** Читает сохранённую роль экрана. */
export function getSavedRole(): ClientRole | null {
  const value = localStorage.getItem(ROLE_KEY);
  if (value === 'display' || value === 'dj') {
    return value;
  }
  return null;
}

/** Запоминает роль экрана. */
export function saveRole(role: ClientRole): void {
  localStorage.setItem(ROLE_KEY, role);
}

/** Сбрасывает сохранённую роль. */
export function clearSavedRole(): void {
  localStorage.removeItem(ROLE_KEY);
}
